<template>
  <div class="to_view_more center margin_auto" @click="jump1">查看更多</div>
</template>

<script>
export default {
  props: {
    url: Object,
  },
  methods:{
    jump1(){
      let tzobj = JSON.parse(JSON.stringify(this.url))
      this.$router.push(this.url)
    }
  }
};
</script>

<style lang="scss" scope>
.to_view_more {
  cursor: pointer;
  width: 140px;
  height: 40px;
  border: 1px solid #666666;
  color: #666666;
  border-radius: 5px;
  margin-top: 40px;
}
</style>